export const queryConfig = {
  staleTime: {
    short: 5 * 60 * 1000,
    medium: 10 * 60 * 1000,
    long: 30 * 60 * 1000,
  },
  retry: {
    none: 0,
    once: 1,
    twice: 2,
    default: 2,
  },
  refetchOnWindowFocus: false,
  refetchOnMount: true,
  refetchOnReconnect: true,
};

